import React from "react";
import { Row, Container, Col } from 'react-bootstrap';

import './GeneralInformation.scss';

export default function GeneralInformation() {
  return (
    <div className="general-information-wrapper">
      <Container className="general-information-container d-flex">
        <Row>
          <Col className="d-flex flex-column justify-content-center" lg={7}>
            <h2 className="general-information-title">How often should you<br /> review your life insurance?</h2>
            <p>Once a year is a good rule of thumb for assessing your life insurance policy. Annual reviews enable you to have a regular opportunity to make sure your coverage still fits your needs.
              Additionally, it gives you the chance to check other aspects of your policy to make sure they are up to date- including beneficiary designations.</p>
          </Col>
          <Col className="image-container d-flex align-items-center justify-content-center decorative-circle" lg={5}>
            <img src="/product-landing/term/circle2.png" alt="" className="rounded-circle" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}